import ProfileDetailsActions from "@redux/feature/Profile/action/profileDetailsAction";
import ClientRatingSummaryActions from "@redux/feature/Profile/action/ClientRatingSummaryActions";
import RMDetailsRatingActions from "@redux/feature/Profile/action/rmDetailsRatingAction";
import CriticalActivityActions from "@redux/feature/Profile/action/creaticalActivityActions";
import RatingDetailActions from "@redux/feature/Profile/action/ratingDetailsAction";
import RouteDetailsActions from "@redux/feature/Profile/action/RouteDetailsActions";
export default (function () {
    return {
        profile: {
            clientRatingSummaryActions: new ClientRatingSummaryActions(),
            profileDetails: new ProfileDetailsActions(),
            ratingDetails: new RatingDetailActions(),
            rmDetailsRatingActions: new RMDetailsRatingActions(),
            criticalActivityActions: new CriticalActivityActions(),
            routeDetails: new RouteDetailsActions(),
        },
    };
});
